export default {
  eyebrow: 'Portal de partner',
  title: 'Marca',
  description: 'El aspecto de tu portal de marca blanca y página de inicio de sesión.',
  page: {
    read_only_notice: 'Solo lectura. Haz clic en Editar para cambiar cualquier valor.',
    editing_notice: 'Editando — los cambios son visibles para tu equipo y clientes.',
  },
  branding: {
    scope_hint:
      'Se aplica a tu portal de marca blanca y página de inicio de sesión — no a los escaparates de tus restaurantes, que tienen marca propia por restaurante.',
    upload: 'Subir logotipo',
    logo: {
      label: 'Logotipo',
      hint: 'Se muestra en tus superficies de marca blanca.',
    },
    circle_logo: {
      label: 'Favicon / logotipo circular',
      hint: 'Logotipo cuadrado usado como favicon y avatar. Opcional — se puede eliminar.',
    },
    splash_image: {
      label: 'Imagen de inicio de sesión',
      hint: 'Se muestra en tu página de inicio de sesión de marca blanca. Recomendado: al menos 1200 px de ancho. Opcional — se puede eliminar.',
    },
    footer_note: 'Más opciones de marca (colores secundarios) disponibles próximamente.',
  },
  form: {
    primary_color: {
      label: 'Color principal de marca',
      hint: 'Define el tema de tu portal de partner e inicio de sesión.',
    },
    dashboard_subdomain: {
      label: 'Slug de inicio de sesión del partner',
      hint: 'Slug en minúsculas — identifica tu marca en el enlace de inicio de sesión del equipo (?partner=…).',
      placeholder: 'nombre-partner',
    },
    login_url: {
      label: 'Enlace de inicio de sesión del equipo',
      hint: 'Comparte este enlace con tu equipo — abre la página de inicio de sesión con tu marca.',
    },
    file: {
      label: 'Imagen',
    },
  },
  login_url_warning: {
    title: '¿Cambiar el enlace de inicio de sesión del equipo?',
    description:
      'Tu enlace de inicio de sesión del equipo cambiará a {{url}}. Comparte el nuevo enlace a partir de ahora — el antiguo dejará de mostrar tu marca.',
    description_no_url:
      'Tu enlace de inicio de sesión del equipo cambiará. Comparte el nuevo enlace a partir de ahora — el antiguo dejará de mostrar tu marca.',
  },
  login_url_changed: {
    title: 'Enlace de inicio de sesión del equipo cambiado',
    description:
      'Tu equipo ahora inicia sesión en {{url}}. Guarda el nuevo enlace en marcadores y compártelo con tu equipo.',
  },
  buttons: {
    edit: 'Editar',
    cancel: 'Cancelar',
    save: 'Guardar',
  },
  toasts: {
    load_error: 'No se pudo cargar tu marca.',
    failed_to_save_changes: 'No se pudieron guardar los cambios',
    changes_got_saved: 'Los cambios se guardaron',
    logo_uploaded: 'Logotipo subido',
    logo_upload_failed: 'Error al subir el logotipo',
    logo_removed: 'Logotipo eliminado',
    logo_remove_failed: 'Error al eliminar el logotipo',
    file_too_large: 'El archivo es demasiado grande. El tamaño máximo es {{max}} MB.',
    image_too_narrow: 'La imagen de inicio de sesión debe tener al menos {{min}} px de ancho.',
  },
};
